__turbopack_context__.v({
  "container": "CloudinarySolarnetImage-module___ZlLXG__container",
  "fadeInItems": "CloudinarySolarnetImage-module___ZlLXG__fadeInItems",
  "loaded": "CloudinarySolarnetImage-module___ZlLXG__loaded",
  "spacing--lg": "CloudinarySolarnetImage-module___ZlLXG__spacing--lg",
  "spacing--md": "CloudinarySolarnetImage-module___ZlLXG__spacing--md",
  "spacing--sm": "CloudinarySolarnetImage-module___ZlLXG__spacing--sm",
  "spacing--xl": "CloudinarySolarnetImage-module___ZlLXG__spacing--xl",
  "spacing--xs": "CloudinarySolarnetImage-module___ZlLXG__spacing--xs",
  "spacing--xxl": "CloudinarySolarnetImage-module___ZlLXG__spacing--xxl",
  "spacing--xxs": "CloudinarySolarnetImage-module___ZlLXG__spacing--xxs",
  "spacing--xxxl": "CloudinarySolarnetImage-module___ZlLXG__spacing--xxxl",
  "spacing--xxxs": "CloudinarySolarnetImage-module___ZlLXG__spacing--xxxs",
});
